// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1280":"8fac8903","6074":"4ce33dfe"}[chunkId] + ".chunk.css";
};